// ── Tooltip simples ─────────────────────────────────────────────────────────

export class AppTooltip extends HTMLElement {
  static get observedAttributes() {
    return ["content", "position"];
  }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  private render() {
    const content = this.getAttribute("content") || "";
    this.title = content;
    this.style.display = "inline-flex";
    this.style.alignItems = "center";
  }
}

if (!customElements.get("app-tooltip")) {
  customElements.define("app-tooltip", AppTooltip);
}

// ── Skeleton Loading ────────────────────────────────────────────────────────

export class AppSkeleton extends HTMLElement {
  static get observedAttributes() {
    return ["width", "height", "variant", "rows"];
  }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  private render() {
    const width   = this.getAttribute("width")   || "100%";
    const height  = this.getAttribute("height")  || "16px";
    const variant = this.getAttribute("variant") || "text"; // text | card | table | kpi-grid | circle
    const rows    = parseInt(this.getAttribute("rows") || "3");

    this.style.display = "block";

    if (variant === "table") {
      // Skeleton para tabela — linhas múltiplas
      this.innerHTML = `
        <div style="display: flex; flex-direction: column; gap: 0;">
          ${Array.from({ length: rows }).map((_, i) => `
            <div style="display: flex; gap: 12px; padding: 10px 14px; border-bottom: 1px solid var(--color-border-subtle);">
              <div class="skeleton" style="width: 80px; height: 12px; border-radius: 2px;"></div>
              <div class="skeleton" style="flex: 1; height: 12px; border-radius: 2px;"></div>
              <div class="skeleton" style="width: 100px; height: 12px; border-radius: 2px;"></div>
              <div class="skeleton" style="width: 60px; height: 12px; border-radius: 2px;"></div>
              <div class="skeleton" style="width: 70px; height: 20px; border-radius: 2px;"></div>
            </div>
          `).join("")}
        </div>
      `;
      return;
    }

    if (variant === "kpi-grid") {
      // Skeleton para grid de KPIs
      this.innerHTML = `
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 16px;">
          ${Array.from({ length: rows || 4 }).map(() => `
            <div style="background: var(--color-surface-primary); border: 1px solid var(--color-border-default); border-radius: 2px; padding: 18px 20px; display: flex; flex-direction: column; gap: 10px;">
              <div class="skeleton" style="width: 60%; height: 10px;"></div>
              <div class="skeleton" style="width: 40%; height: 28px;"></div>
              <div class="skeleton" style="width: 50%; height: 10px;"></div>
            </div>
          `).join("")}
        </div>
      `;
      return;
    }

    if (variant === "card") {
      this.innerHTML = `
        <div style="background: var(--color-surface-primary); border: 1px solid var(--color-border-default); border-radius: 2px; padding: 20px; display: flex; flex-direction: column; gap: 12px;">
          <div class="skeleton" style="width: 40%; height: 14px;"></div>
          <div class="skeleton" style="width: 100%; height: 12px;"></div>
          <div class="skeleton" style="width: 80%; height: 12px;"></div>
          <div class="skeleton" style="width: 60%; height: 12px;"></div>
        </div>
      `;
      return;
    }

    // text / circle / default
    this.className = "skeleton";
    this.style.width = width;
    this.style.height = height;
    if (variant === "circle") {
      this.style.borderRadius = "var(--radius-full)";
    }
  }
}

if (!customElements.get("app-skeleton")) {
  customElements.define("app-skeleton", AppSkeleton);
}
